export const REMINDER_RECIPIENTS = [
  {
    reminder_type: "project_deadline",
    title: "Project Reminders",
    recipients: ["Primary Manager", "Secondary Manager"],
  },
  {
    reminder_type: "job_deadline",
    title: "Job Reminders",
    recipients: [
      "Vendor",
      "Primary Project Manager (once overdue)",
      "Secondary Project Manager (once overdue)",
    ],
  },
  {
    reminder_type: "client_invoice_due",
    title: "Client Invoice Reminders",
    recipients: ["Account Manager"],
  },
  {
    reminder_type: "vendor_invoice_due",
    title: "Vendor Invoice Reminders",
    recipients: ["Account Manager (before due date)", "Vendor (once overdue)"],
  },
  {
    reminder_type: "quote_expiration",
    title: "Quotation Reminders",
    recipients: ["Primary Manager"],
  },
];
